// Cache en memoria — los WKT de geocercas raramente cambian de geometría;
// tras la primera ingesta los siguientes reload/refresh re-parsean los
// mismos strings. Trace mostraba 11.7 ms en `pair` (el split+map+Number)
// solo en boot. El cache devuelve el GeoJSON parseado para repeticiones
// del mismo string. Cap defensivo en 5000 entradas (~50 KB en strings)
// por si entrara WKT generado dinámicamente en algún flujo futuro.
const _wktCache = new Map()
const _WKT_CACHE_MAX = 5000

export function wktToGeoJSON(wkt) {
  if (!wkt || typeof wkt !== 'string') return null
  const cached = _wktCache.get(wkt)
  if (cached !== undefined) return cached
  const match = wkt.match(/POLYGON\s*\(\((.+)\)\)/i)
  if (!match) {
    if (_wktCache.size < _WKT_CACHE_MAX) _wktCache.set(wkt, null)
    return null
  }
  // Kalan WKT uses lat-first order: POLYGON((lat lon, lat lon, ...))
  // GeoJSON requires lon-first: [lon, lat]
  const coords = match[1].split(',').map(pair => {
    const parts = pair.trim().split(/\s+/).map(Number)
    return [parts[1], parts[0]] // swap: [lon, lat] for GeoJSON
  })
  // GeoJSON spec exige LinearRing cerrado: el último coordinate debe ser
  // igual al primero. Algunas geocercas del backend (creadas por el editor
  // legacy) llegan con 4 vértices sin cerrar — OpenLayers las auto-cerraba
  // al renderizar, MapLibre no, y dejaba un lado abierto + fill vacío.
  if (coords.length >= 3) {
    const first = coords[0]
    const last = coords[coords.length - 1]
    if (first[0] !== last[0] || first[1] !== last[1]) {
      coords.push([first[0], first[1]])
    }
  }
  const result = { type: 'Polygon', coordinates: [coords] }
  if (_wktCache.size < _WKT_CACHE_MAX) _wktCache.set(wkt, result)
  return result
}
